var render = function render(){var _vm=this,_c=_vm._self._c;return _c('small',{staticClass:"form-text text-muted text-right"},[_c('span',{class:{'invalid-length': _vm.length > _vm.maxlength}},[_vm._v(_vm._s(_vm.length || 0))]),_vm._v(" "),_c('span',[_vm._v(" / "+_vm._s(_vm.maxlength))])])
}
var staticRenderFns = []

export { render, staticRenderFns }